/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_HelpInputs */



/**
* | output |
* | --- |
* | "Help" |
*
* @param {Layout_Header_HelpInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_help = /** @type {((inputs?: Layout_Header_HelpInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_HelpInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hilfe")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aide")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("帮助")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("說明")
	if (locale === "ko") return /** @type {LocalizedString} */ ("도움말")
	return /** @type {LocalizedString} */ ("Help")
});